import { ReleasedProduct } from "../../core/models/shared/releaseProduct";

export const MISC_RELEASED_PRODUCT: ReleasedProduct = {
  id: 0,
  dataAreaIdD365: null,
  itemNumberD365: "Misc",
  productSearchNameD365: null,
  inventoryUnitSymbolD365: null,
  unitCostDateD365: null,
  purchaseSalesTaxItemGroupCodeD365: null,
  purchaseUnitSymbolD365: null,
  salesPriceQuantityD365: null,
  productNumberD365: null,
  purchasePriceDateD365: null,
  isRetailDiscountPOSRegistrationProhibitedD365: null,
  defaultOrderTypeD365: null,
  productTaxationOriginD365: null,
  purchasePriceQuantityD365: null,
  unitCostQuantityD365: null,
  productGroupIdD365: null,
  projectCategoryIdD365: null,
  modifiedDateTime1D365: null,
  searchNameD365: null,
  productTypeD365: null,
  salesPriceD365: null,
  itemModelGroupIdD365: null,
  modifiedBy1D365: null,
  salesSalesTaxItemGroupCodeD365: null,
  salesPriceDateD365: null,
  salesUnitSymbolD365: null,
  purchasePriceD365: null,
  unitCostD365: null,
  costPriceD365: null,
  trackingDimensionGroupNameD365: null,
  storageDimensionGroupNameD365: null,
  nameD365: null,
  financialDimensionD365: null,
  productSubTypeD365: null,
  storeD365: null,
  descriptionD365: null,
  ownerD365: null,
  lowStockLevelD365: 0,
  productLifeCycleStateD365: null,
  siteD365: null,
  warehouseD365: null,
  defaultReceiptLocationD365: null,
  departmentD365: null,
  locationD365: null,
  productCategoryD365: null,
  productSubCategoryD365: null,
  programD365: null,
  defaultIssueLocationD365: null,
  itemTypeD365: null,
  createdBy: "",
  createdDate: "",
  lastModifiedBy: "",
  lastModifiedDate: "",
  isActive: false,
  poStopped: null,
  soStopped: null,
};
